<template>
  <div id="body-wrapper">
  <div id="wrapper">
    <div id="boxer">
      <div class="img-wrapper">
        <img alt="Loto-Québec" src="data:image/svg+xml;base64,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"/>
      </div>
      <div class="center-wrapper">
        <p class="titre">Oups... Erreur {{code}}</p>
        <p>La page ou la fonction que vous tentez d'utiliser a été retirée ou est non fonctionnelle.<p>
        <a href="/sports/">Retour à l'accueil</a>
        <p class="titre">Oops... Error {{code}}</p>
        <p>The page or function that you requested was removed or is not functional.</p>
        <a href="/sports/">Return to homepage</a>
      </div>
      <div class="bottom-wrapper">
        <img alt ="18+" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAOCAYAAABth09nAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc2MzUzNjY3QTFGNjExRTdBRUVBRUI0MUQ2OTFFODgwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc2MzUzNjY4QTFGNjExRTdBRUVBRUI0MUQ2OTFFODgwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzYzNTM2NjVBMUY2MTFFN0FFRUFFQjQxRDY5MUU4ODAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzYzNTM2NjZBMUY2MTFFN0FFRUFFQjQxRDY5MUU4ODAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7lTGbVAAABcElEQVR42tyWwSsEYRTA51vyB4gctt3THpxQ3Ihy4ODCxcndxYHkri3lqDi4KKKEG3HwB7hIbJHkoLSb1RZbbsLnN3qT1zQzXHZ22le/3vvevPnmvb73ZsZYa51GkJQxxnFBBuECriCv/BnYgDK4VX9AAeagyYuLIhbhRKbhCL7sr2zKtXYo2XDZCdivBbI+X81xQhL0CplRvhPohhGoKH+HL+keqMZdSEqedQZbAQem+2KfNinAKfZ5SEz9ZgRyJNcvs+GXPSiJvUTleVjHHhXfLveWEzX1JDjrby3xT8B7QPvdQlpiBtx2Et7kelVR89Zq/qO4KdS2LItwAG0wCZ1wSUwf+hrGJS4HK2pd/xNB3yhfVsXOK/9ikoY9TNJeLvCs/E/KziRl2KPkXr2ZVqm8C4axF1TMne8ed/iXEzXs6DH4jPggFqH1H3vH2loV+fVwefw5BmOOUUNwCK8q9gHWoJeYlyS0lmmUn8ZvAQYAMdLtgCf+5ukAAAAASUVORK5CYII="/>
        &copy; 2020 Loto-Québec et ses filiales. Tous droits réservés.
      </div>
    </div>
  </div>
  </div>
</template> 

<script>
  export default {
		name:"PageErreur",
		props: ['code'],
    created: function() {
      document.getElementsByTagName("body")[0].style = "background-color: #00407d";
    }
  }
</script>

<style lang="scss">
  
    #body-wrapper {
      background-color:#00407d;
			color: #fff;
			font-family : 'Lato', sans-serif;
			margin:0;
			padding:0;
		}
		#wrapper {
      background-color:#00407d;
			color: #fff;
			font-family : 'Lato', sans-serif;
			margin:0;
			padding:0;

			display: block;
			font-size: 10px;
			margin: 0 auto;	
			max-width: 44em;			
			text-align:center;
      width: 100%;

      padding-top:8rem;

      a, 
      a:link, 
      a:visited {
        color: #a1dbd2;
        text-decoration: underline;
      }
      a:focus, 
      a:hover{
        color: #fff;
      }	

		}
		#boxer{
			font-size:1.8em;
			line-height:1.8em;
			padding:0 1em;
		}
		#boxer .img-wrapper{
			border-bottom: dotted 0.1em #6a839b;
			border-top: dotted 0.1em #6a839b;
			//margin-top:8em;
		}
		#boxer .img-wrapper img{
			height:2.5em;
			margin:1em 0 0.5em;
		}
		#boxer p{
			margin:0;
		}	
		
		#boxer .center-wrapper{
			margin: 0 0.5em;
		}
		#boxer .titre{
			font-size:1.1em;
			line-height:1.1em;
			margin-top:1em;
		}	
		#boxer .bottom-wrapper{
			border-top: dotted 0.1em #6a839b;
			font-size:0.7em;
			line-height:1.8em;
			margin-top:2em;
			padding-top:1em;
		}
		
		@media screen and (max-width: 767px){
			#boxer .img-wrapper{
				margin-top:1em;
			}
			#boxer .img-wrapper img{
				height:2em;
			}			
		}	

</style>
